import { render, staticRenderFns } from "./ShowPaperReview.vue?vue&type=template&id=4f899b5e&scoped=true"
import script from "./ShowPaperReview.vue?vue&type=script&lang=js"
export * from "./ShowPaperReview.vue?vue&type=script&lang=js"
import style0 from "./ShowPaperReview.vue?vue&type=style&index=0&id=4f899b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f899b5e",
  null
  
)

export default component.exports